import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonDirective, IconDirective } from 'shared/ui-common';

import { CommentService } from '@treetop/shared/comments';

@Component({
  selector: 'tt-comments-footer-button',
  standalone: true,
  imports: [ButtonDirective, IconDirective, MatIconModule, TranslocoPipe],
  templateUrl: './comments-footer-button.component.html',
  styleUrl: './comments-footer-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentsFooterButtonComponent {
  private commentService = inject(CommentService, { optional: true });

  protected comments = computed(() => this.commentService?.orderedComments() ?? []);
  protected openCommentsCount = computed(() => this.comments().filter((comment) => !comment.resolved).length);
  protected isOpen = computed(() => this.commentService?.isCommentsBarOpen() ?? false);

  protected handleToggle(): void {
    if (this.isOpen()) {
      this.commentService?.closeCommentsBar();
    } else {
      this.commentService?.openCommentsBar();
    }
  }
}
